// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1OAuthTokenResponseSchema = z.object({
  access_token: z.coerce.string().min(1).describe("OAuth 2.0 access token"),
  token_type: z.coerce.string().min(1).describe("Token type (always Bearer)"),
  expires_in: z.nullable(z.number().int().describe("Token expiration time in seconds (null for non-expiring tokens)")),
  refresh_token: z.nullable(z.coerce.string().describe("OAuth 2.0 refresh token (if applicable)")),
  scope: z.coerce.string().min(1).describe("OAuth 2.0 scope"),
  created_at: z.number().int().describe("Token creation timestamp (Unix timestamp)"),
});
